// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"e45c567b","449":"31b4888d","466":"fd45e883","707":"72aec9bc"}[chunkId] + ".css";
};